/* eslint-disable prettier/prettier */
import React, { useCallback, useEffect, useState, useContext, useMemo } from 'react';
import P from 'prop-types';
import './styles.css';
//import { InputText } from '../InputText';
import { DetalhesListGroup } from '../../templates/DetalhesListGroup';
import { LabelPreco } from '../LabelPreco';
import { Image } from '../Image';
import { TemplateSelector } from '../../templates/TemplateSelector';
import { DetalhesRodape } from '../DetalhesRodape';
import { ArredondaValores, Capitalize, HandleAddItem, RemoveItensEdicao, UpdateItensCount, removeEmojis } from '../../utils/utils';
import { GeraID } from '../../utils/utils';
import { toast } from 'react-toastify';
import { GlobalContext } from '../../contexts/HomeContext';
import { Tabs } from '../Tabs';
import { useForm } from 'react-hook-form';
//import { PieChart } from 'react-minimal-pie-chart';

//const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

export const Detalhes = ({ param, closeModal }) => {
  const { dadosApp, setSacola } = useContext(GlobalContext);
  const [PRODUTO, setProduto] = useState(param.item);
  const [montagem, setMontagem] = useState(param.montagem.montagem);
  const [tipoPizza, setTipoPizza] = useState(PRODUTO.tipoPizza === 'FRACAO' ? 1 : 0); // 0 = INTEIRA, 1 = FRAÇÃO
  const [tamanho, setTamanho] = useState(0);
  const [TOTAL, setTOTAL] = useState(0); //(ArredondaValores(calculaTotal(PRODUTO, montagem), 2));
  const [multPrecos, setMultPrecos] = useState(
    dadosApp.Cardapio.MultPreco.filter((p) => p.codigo_principal === param.item.codigo),
  );
  const {
    register,
    setValue,
    handleSubmit,
    //formState: { errors },
  } = useForm();

  //const [unmounted, setUnmounted] = useState(false);

  //var multPrecos = useMemo(() => {
  //  return dadosApp.Cardapio.MultPreco.filter((p) => p.codigo_principal === param.item.codigo);
  //}, [dadosApp.Cardapio.MultPreco, param.item.codigo]);

  const handleMultPrecos = useCallback(() => {
    let mult = 0;
    const codigoPrincipal = dadosApp.Cardapio.MultPreco.filter((p) => p.codigo_mult === param.item.codigo);
    if (codigoPrincipal?.length > 0) {
      mult = dadosApp.Cardapio.MultPreco.filter((p) => p.codigo_principal === codigoPrincipal[0].codigo_principal);
    }

    const Index = mult?.findIndex((p) => p.titulo === PRODUTO.tamanho);

    if (Index !== -1) {
      setTamanho(Index);
      setMultPrecos(mult);
    }
  }, [PRODUTO, setTamanho, dadosApp.Cardapio.MultPreco, param.item]);

  useEffect(() => {
    if (multPrecos?.length === 0 && param.item.tamanho) handleMultPrecos();
  }, [handleMultPrecos, multPrecos, param]);

  const group = useMemo(() => {
    return param.montagem.group.includes(`Escolha até ${PRODUTO.pizza_qtd_max} sabores`) && tipoPizza == 0
      ? param.montagem.group.slice(1, param.montagem.group.length)
      : param.montagem.group;
  }, [PRODUTO.pizza_qtd_max, tipoPizza, param.montagem.group]);

  const itensEdicao = param.montagem.itensEdicao;

  if (tipoPizza == 1) PRODUTO.quantidade = 1;
  if (PRODUTO.quantidade === 0) PRODUTO.quantidade = 1; // correção do bug pizza identificado pelo cliente do sergio jafa pizza

  const initialValIsCompleted = () => {
    if (group.length > 1) return false;
    if (group.length == 1) {
      if (group[0] == 'Acompanhamento Extra') {
        return true;
      }
    }
  };

  const [isCompleted, setIsCompleted] = useState(initialValIsCompleted);

  const calculaTotal = useCallback(
    (_produto, _montagem) => {
      let _total = 0;
      //let _precoMaior = 0;
      // calcula a pizza
      if (tipoPizza == 1) {
        if (dadosApp.Empresa.Config.pizza_cobranca.toUpperCase() == 'MAIOR') {
          let precoMaior = _montagem
            .filter((p) => p.TipoMontagem == 'PIZZA' && p.Produto.quantidade > 0)
            .sort(function (a, b) {
              return b.Produto.preco_app - a.Produto.preco_app;
            });

          if (precoMaior.length > 0) {
            _total += precoMaior[0].Produto.preco_app;
          }
        } else {
          const qtdeTotalSelecionada = _montagem
            .filter((p) => p.TipoMontagem == 'PIZZA' && p.Produto.quantidade > 0)
            .reduce(function (a, b) {
              return a + b.Produto.quantidade;
            }, 0);
          const qtdeFracionada = ArredondaValores(1 / qtdeTotalSelecionada, 3);
          const sobraFracao = ArredondaValores(1 - qtdeTotalSelecionada * qtdeFracionada, 3);
          _montagem
            .filter((p) => p.TipoMontagem == 'PIZZA' && p.Produto.quantidade > 0)
            .map((item) => {
              if (item.Produto.codigo == _produto.codigo)
                _total += ArredondaValores(
                  item.Produto.preco_app * (qtdeFracionada * item.Produto.quantidade + sobraFracao),
                  2, // antes eram 3 casas decimais
                );
              else _total += ArredondaValores(item.Produto.preco_app * (qtdeFracionada * item.Produto.quantidade), 2); // antes eram 3 casas decimais
            });
        }
      } else {
        _total = _produto.preco_app * _produto.quantidade;
      }

      // calcula os itens obrigatórios e adicionais

      const arrayValores = _montagem.map((item) => {
        let val = 0;
        if (!isNaN(item.Produto.quantidade) && item.TipoMontagem !== 'COMBO' && item.TipoMontagem !== 'PIZZA') {
          if (item.Produto.quantidade > 0) {
            //val += item.valor_unitario * item.quantidade;
            /* ANTES EU APENAS CALCULAVA OS VALORES E SUAS QUANTIDADES
             POIS EU JÁ TRAZIA A QTDE DOS ITENS DE MONTAGEM E OBRIGATÓRIOS MULTIPLICADOS PELA
             QUANTIDADE DO PRODUTO PRINCIPAL (ver método => handleQtdeMontagem)
             AGORA, EU NÃO TRAGO MAIS AS QUANTIDADES SOMADAS
             EU SÓ SOMO AO GRAVAR OS ITENS
             E QUANDO O USUÁRIO EDITA
             EU TRAGO AS QUANTIDADES DIVIDIDAS PARA QUE FIQUE COERENTE NA EDIÇÃO */
            val += item.Produto.preco_app * item.Produto.quantidade * _produto.quantidade;
          }
        }
        return val;
      });
      _total += arrayValores.reduce(function (a, b) {
        return a + b;
      }, 0);

      //setTOTAL(ArredondaValores(_total), 2);
      setTOTAL(_total);
    },
    [dadosApp, tipoPizza],
  ); // calcula o total

  // eslint-disable-next-line no-unused-vars
  const calculaTotalOld = useMemo(() => {
    let _total = 0;
    // calcula a pizza
    if (tipoPizza == 1) {
      if (dadosApp.Empresa.Config.pizza_cobranca.toUpperCase() == 'MAIOR') {
        let precoMaior = montagem
          .filter((p) => p.TipoMontagem == 'PIZZA' && p.Produto.quantidade > 0)
          .sort(function (a, b) {
            return b.Produto.preco_app - a.Produto.preco_app;
          });

        if (precoMaior.length > 0) {
          _total += precoMaior[0].Produto.preco_app;
        }
      } else {
        const qtdeTotalSelecionada = montagem
          .filter((p) => p.TipoMontagem == 'PIZZA' && p.Produto.quantidade > 0)
          .reduce(function (a, b) {
            return a + b.Produto.quantidade;
          }, 0);
        const qtdeFracionada = ArredondaValores(1 / qtdeTotalSelecionada, 3);
        const sobraFracao = ArredondaValores(1 - qtdeTotalSelecionada * qtdeFracionada, 3);
        montagem
          .filter((p) => p.TipoMontagem == 'PIZZA' && p.Produto.quantidade > 0)
          .map((item) => {
            if (item.Produto.codigo == PRODUTO.codigo)
              _total += ArredondaValores(
                item.Produto.preco_app * (qtdeFracionada * item.Produto.quantidade + sobraFracao),
                2, // antes eram 3 casas decimais
              );
            else _total += ArredondaValores(item.Produto.preco_app * (qtdeFracionada * item.Produto.quantidade), 2); // antes eram 3 casas decimais
          });
      }
    } else {
      _total = PRODUTO.preco_app * PRODUTO.quantidade;
    }

    // calcula os itens obrigatórios e adicionais
    const arrayValores = montagem.map((item) => {
      let val = 0;
      if (!isNaN(item.Produto.quantidade) && item.TipoMontagem !== 'COMBO' && item.TipoMontagem !== 'PIZZA') {
        if (item.Produto.quantidade > 0) {
          // CORREÇÃO DO CALCULO DOS ITENS ADICIONAIS MULTIPLICADOS PELA QUANTIDADE DO PRODUTO BASE
          if (item.TipoMontagem === 'ADICIONAL') {
            val += item.Produto.preco_app * (item.Produto.quantidade * PRODUTO.quantidade);
          } else {
            val += item.Produto.preco_app * item.Produto.quantidade;
          }
          /* ANTES EU APENAS CALCULAVA OS VALORES E SUAS QUANTIDADES
               POIS EU JÁ TRAZIA A QTDE DOS ITENS DE MONTAGEM E OBRIGATÓRIOS MULTIPLICADOS PELA
               QUANTIDADE DO PRODUTO PRINCIPAL (ver método => handleQtdeMontagem)
               AGORA, EU NÃO TRAGO MAIS AS QUANTIDADES SOMADAS
               EU SÓ SOMO AO GRAVAR OS ITENS
               E QUANDO O USUÁRIO EDITA
               EU TRAGO AS QUANTIDADES DIVIDIDAS PARA QUE FIQUE COERENTE NA EDIÇÃO */
          //val += (item.Produto.preco_app * item.Produto.quantidade) * PRODUTO.quantidade;
          //val += item.Produto.preco_app * (item.Produto.quantidade * PRODUTO.quantidade);
        }
      }
      return val;
    });
    _total += arrayValores.reduce(function (a, b) {
      return a + b;
    }, 0);

    return _total;
  }, [PRODUTO, dadosApp, montagem, tipoPizza]); // calcula o total

  const handleSetTamanho = (aba) => {
    if (multPrecos[aba].codigo_mult === PRODUTO.codigo) return;

    const produtoSelected = dadosApp.Cardapio.Produtos.filter((item) => item.codigo === multPrecos[aba].codigo_mult);

    if (produtoSelected?.length > 0) {
      setTamanho(aba);
      produtoSelected[0].is_principal_multpreco = true;
      produtoSelected[0].quantidade = PRODUTO.quantidade;
      produtoSelected[0].observacao = PRODUTO.observacao; // prevalece a mesma obs
      //produtoSelected[0].observacao = multPrecos[aba].titulo;
      setProduto(produtoSelected[0]);
      calculaTotal(produtoSelected[0], montagem);
    }
  };

  // const handleClearMontagem = useCallback(() => {
  //   // limpa possível itens com sujeira
  //   dadosApp.Cardapio.Produtos.filter((item) => item.id > 0).map((item) => {
  //     item.id = 0;
  //     item.quantidade = 0;
  //     item.quantidade_texto = '';
  //     item.quantidade_fracionada = 0;
  //     return { ...item };
  //   });

  //   const newMontagem = montagem.map((item) => {
  //     item.Produto.id = 0;
  //     item.Produto.quantidade = 0;
  //     item.Produto.quantidade_texto = '';
  //     item.Produto.quantidade_fracionada = 0;
  //     return { ...item };
  //   });
  //   setMontagem(newMontagem);
  // }, [montagem, dadosApp.Cardapio.Produtos]);

  const handleQtdeSelecionada = useCallback(
    (filter) => {
      let qtdeSelecionada = 0;
      montagem
        .filter((p) => p.Titulo === filter)
        .map((item) => {
          if (!isNaN(item.Produto.quantidade)) {
            if (item.Produto.quantidade > 0) {
              qtdeSelecionada += item.Produto.quantidade;
            }
          }
        });
      return qtdeSelecionada;
    },
    [montagem],
  );

  // verifica se a montagem esta completa e habilita o botão de adicionar
  const handleIsCompleted = useCallback(
    (quantidade, tipoPizza, group, handleQtdeSelecionada, isCompleted, montagem, isPrincipal = false) => {
      calculaTotal(PRODUTO, montagem);

      let completed = true;
      group.map((g) => {
        if (isPrincipal) {
          let qtdeSelecionada = 0;
          if (g !== 'Acompanhamento Extra') {
            qtdeSelecionada = handleQtdeSelecionada(g);
          }

          // criei esta variavel para desativar a lógica que multiplicava as quantidades quando o produto principal tinha quantidade maior que 1
          const logicaAntiga = false;
          if (logicaAntiga) {
            montagem
              .filter((p) => p.Titulo === g && p.TipoMontagem !== 'PIZZA')
              .map((p) => {
                switch (p.TipoMontagem) {
                  case 'COMBO':
                    // se for um combo de apenas um item obrigatorio
                    if (isPrincipal && p.Produto.quantidade > 0 && p.QtdeObrigatoria == 1) {
                      p.Produto.quantidade = quantidade;
                    }
                    if (p.QtdeObrigatoria > 1) {
                      p.QtdeObrigatoria = p.QtdeObrigatoriaOriginal * quantidade;

                      // se por acaso o usuário trocou a quantidade do Produto Principal e depois reduziu
                      // zera a quantidade selecionada
                      if (qtdeSelecionada > p.QtdeObrigatoria && p.TipoMontagem == 'COMBO') {
                        p.Produto.quantidade = 0;
                        //             foreach(var zera in group)
                        // zera.Produto.quantidade = 0;
                      }
                    }
                    break;

                  case 'OBRIGATORIO':
                    //if (PRODUTO.tipoPizza == 'INTEIRA' && p.Produto.quantidade > 0) {
                    if (tipoPizza == 'INTEIRA' && p.Produto.quantidade > 0) {
                      p.Produto.quantidade = quantidade;
                    }
                    break;

                  default:
                    break;
                }
              });
          }
        }

        if (g !== 'Acompanhamento Extra') {
          const element = document.getElementById('group' + g);
          if (!element) {
            completed = false;
            return;
          }
        }
      });
      if (completed !== isCompleted) {
        setIsCompleted(completed);
      }
    },
    [PRODUTO, calculaTotal],
  );

  // lida com o clique do item selecionado nos casos de Obrigatórios e Combo onde a quantidade obrigatória é 1
  const handleOnItemSelect = useCallback(
    (produto) => {
      if (
        (produto.TipoMontagem === 'OBRIGATORIO' && produto.QtdeObrigatoria == 1) ||
        (produto.TipoMontagem == 'COMBO' && produto.QtdeObrigatoria == 1)
      ) {
        const newMontagem = montagem.map((item) => {
          if (item.TipoMontagem === produto.TipoMontagem && item.Titulo === produto.Titulo) {
            if (item.Produto.codigo === produto.Produto.codigo) {
              item.Produto.quantidade = 1;
            }
            if (item.Produto.codigo !== produto.Produto.codigo) {
              item.Produto.quantidade = 0;
            }
          }
          return { ...item };
        });
        setMontagem(newMontagem);
        setTimeout(() => {
          handleIsCompleted(PRODUTO.quantidade, PRODUTO.tipoPizza, group, handleQtdeSelecionada, isCompleted, montagem);
        }, 50);
      }
    },
    [handleIsCompleted, PRODUTO.quantidade, PRODUTO.tipoPizza, group, handleQtdeSelecionada, isCompleted, montagem],
  );

  // lida com a ação do click Somar Quantidade
  const handleMontagemSomar = async (produto) => {
    let QtdeSelecionada = 0;
    if (produto.TipoMontagem === 'PIZZA') {
      QtdeSelecionada = montagem
        .filter((item) => item.TipoMontagem === 'PIZZA' && item.Produto.quantidade > 0)
        .reduce((accumulator, item) => {
          return accumulator + item.Produto.quantidade;
        }, 0);
    }

    // if (produto.Titulo !== 'Acompanhamento Extra' && produto.TipoMontagem !== 'PIZZA') {
    if (produto.TipoMontagem !== 'ADICIONAL' && produto.TipoMontagem !== 'PIZZA') {
      const element = document.getElementById('group' + produto.Titulo);
      if (element) {
        toast.error(Capitalize(produto.Titulo) + ': Quantidade máxima atingida');
        return;
      }
    }

    const newMontagem = await Promise.all(
      montagem.map((item) => {
        if (isNaN(item.QtdeSelecionada)) item.QtdeSelecionada = 0;
        if (item.Titulo === produto.Titulo && item.Produto.codigo === produto.Produto.codigo) {
          switch (item.TipoMontagem) {
            case 'ADICIONAL':
              if (item.QtdeSelecionada < item.QtdMaxima || item.QtdMaxima === 0) {
                if (isNaN(item.Produto.quantidade)) item.Produto.quantidade = 1;
                else item.Produto.quantidade++;
                item.QtdeSelecionada++;
              } else {
                toast.error('Quantidade máxima atingida');
              }
              // if (isNaN(item.Produto.quantidade)) item.Produto.quantidade = 1;
              // else item.Produto.quantidade++;
              //item.QtdeSelecionada++;
              break;

            case 'COMBO':
            case 'OBRIGATORIO':
              //if (item.QtdeObrigatoria && item.QtdeObrigatoria > 1) {
              if (item.QtdeSelecionada < item.QtdeObrigatoria && item.QtdeObrigatoria > 1) {
                if (isNaN(item.Produto.quantidade)) item.Produto.quantidade = 1;
                else item.Produto.quantidade++;
                item.QtdeSelecionada++;
              }
              //item.QtdeSelecionada++; // comentei pois aparentemente estava somando sempre, mesmo quando não era pra somar
              break;

            case 'PIZZA':
              if (QtdeSelecionada < PRODUTO.pizza_qtd_max) {
                if (isNaN(item.Produto.quantidade)) item.Produto.quantidade = 1;
                else item.Produto.quantidade++;
                item.Produto.quantidade_texto = '1/' + parseFloat(QtdeSelecionada + 1);
              } else {
                toast.error('Quantidade máxima de sabores atingida');
              }
              break;

            default:
              break;
          }
        } else if (item.Titulo === produto.Titulo && item.TipoMontagem === 'PIZZA' && item.Produto.quantidade > 0) {
          if (QtdeSelecionada < PRODUTO.pizza_qtd_max) {
            item.Produto.quantidade_texto = '1/' + parseFloat(QtdeSelecionada + 1);
          }
        }
        return { ...item };
      }),
    );

    setMontagem(newMontagem);
    setTimeout(() => {
      handleIsCompleted(PRODUTO.quantidade, PRODUTO.tipoPizza, group, handleQtdeSelecionada, isCompleted, montagem);
    }, 50);
  };

  // lida com a ação de click Subtrair Quantidade
  const handleMontagemSubtrair = (produto) => {
    let newMontagem = montagem.map((item) => {
      if (item.Titulo === produto.Titulo && item.Produto.codigo === produto.Produto.codigo) {
        switch (item.TipoMontagem) {
          case 'ADICIONAL':
            item.Produto.quantidade--;
            item.QtdeSelecionada--;
            break;

          case 'COMBO':
          case 'OBRIGATORIO':
            if (item.QtdeObrigatoria > 1) {
              item.Produto.quantidade--;
            }
            item.QtdeSelecionada--;
            break;
          case 'PIZZA':
            if (item.Produto.codigo === PRODUTO.codigo && item.Produto.quantidade == 1) {
              //return { ...item };
              break;
            } else item.Produto.quantidade--;

            break;

          default:
            break;
        }
      }
      return { ...item };
    });

    // AJUSTA O QUANTIDADE_TEXTO DAS PIZZAS
    if (produto.TipoMontagem === 'PIZZA') {
      let QtdeSelecionada = 0;
      if (produto.TipoMontagem === 'PIZZA') {
        QtdeSelecionada = montagem
          .filter((item) => item.TipoMontagem === 'PIZZA' && item.Produto.quantidade > 0)
          .reduce((accumulator, item) => {
            return accumulator + item.Produto.quantidade;
          }, 0);
      }
      newMontagem = newMontagem.map((item) => {
        if (item.Titulo === produto.Titulo && item.TipoMontagem === 'PIZZA') {
          if (item.Produto.quantidade > 0) item.Produto.quantidade_texto = '1/' + parseFloat(QtdeSelecionada);
          else item.Produto.quantidade_texto = '';
        }
        return { ...item };
      });
    }
    setMontagem(newMontagem);
    setTimeout(() => {
      handleIsCompleted(PRODUTO.quantidade, PRODUTO.tipoPizza, group, handleQtdeSelecionada, isCompleted, montagem);
    }, 50);
  };
  // adiciona o produto na sacola
  const addProduto = (form) => {
    //e.preventDefault();

    // if (form || !form) return;
    //handleIsCompleted(PRODUTO.quantidade, PRODUTO.tipoPizza, group, handleQtdeSelecionada, isCompleted, montagem, true);


    let Pedido = {};
    Pedido.observacao_pedido = removeEmojis(form.observacao); //observacao;
    Pedido.idloja = PRODUTO.idloja;
    Pedido.mesa = dadosApp.Qs.mesa || 0;
    Pedido.local_pedido = dadosApp.Qs.SetorTrabalho || '';
    Pedido.setor_impressao = dadosApp.Qs.SetorTrabalho || '';
    Pedido.posicao = dadosApp.Qs.posicao || 0;

    // em caso de produto com tamanhos
    // aplica esta observação para poder identificar no carrinho
    // o tamanho selecionado
    if (PRODUTO.is_principal_multpreco) PRODUTO.tamanho = multPrecos[tamanho].titulo;

    // GRAVA O PRODUTO PRINCIPAL
    const temMontagem = group.length > 0;
    let PrincipalID = PRODUTO.id;
    if (PrincipalID == 0) PrincipalID = GeraID(PRODUTO.idloja);

    switch (PRODUTO.tipo_produto.toUpperCase()) {
      case 'PIZZA':
        // ***** PIZZA INTEIRA ***** //
        if (tipoPizza == 0) {
          PRODUTO.id = PrincipalID;
          PRODUTO.quantidade_texto = PRODUTO.quantidade.toString();
          PRODUTO.tipoPizza = 'INTEIRA';
          Pedido.tipoPizza = 'INTEIRA';
          Pedido.subtotal = ArredondaValores(PRODUTO.quantidade * PRODUTO.preco_app, 2);
          Pedido.total = Pedido.subtotal;
          Pedido.total_com_servico = Pedido.subtotal;
          if (temMontagem) HandleAddItem(dadosApp.Empresa, PRODUTO, Pedido, Pedido.observacao_pedido, PrincipalID);
          else HandleAddItem(dadosApp.Empresa, PRODUTO, Pedido, Pedido.observacao_pedido);
        } else {
          // ***** PIZZA FRACIONADA ***** //
          const pizzQtdePedacos = montagem
            .filter((p) => p.TipoMontagem == 'PIZZA' && p.Produto.quantidade > 0)
            .reduce(function (a, b) {
              return a + b.Produto.quantidade;
            }, 0);
          const qtdeFracionada = ArredondaValores(1 / pizzQtdePedacos, 3);
          const sobraFracao = ArredondaValores(1 - pizzQtdePedacos * qtdeFracionada, 3);
          // if (pizzQtdePedacos > 1) Pedido.tipoPizza = 'FRACAO';
          // else Pedido.tipoPizza = 'INTEIRA';

          montagem
            .filter((p) => p.TipoMontagem.toUpperCase() == 'PIZZA' && p.Produto.quantidade > 0)
            .map((item) => {
              const qtdeQuebrar = item.Produto.quantidade - 1 == 0 ? 0 : item.Produto.quantidade - 1;
              //console.log(item.Produto.descricao + ' => ' + item.Produto.quantidade, qtdeQuebrar);
              if (pizzQtdePedacos > 1) {
                item.Produto.quantidade_texto = '1/' + pizzQtdePedacos;
                item.Produto.tipoPizza = 'FRACAO';
              } else {
                item.Produto.quantidade_texto = item.Produto.quantidade.toString();
                item.Produto.tipoPizza = 'INTEIRA';
              }

              // produto principal
              if (PRODUTO.codigo === item.Produto.codigo) {
                item.Produto.id = PrincipalID;
                item.Produto.preco_pizza = item.Produto.preco_app;
                item.Produto.quantidade_fracionada = ArredondaValores(qtdeFracionada + sobraFracao, 3);

                if (dadosApp.Empresa.Config.pizza_cobranca.toUpperCase() == 'MEDIA') {
                  Pedido.subtotal = ArredondaValores(item.Produto.quantidade_fracionada * item.Produto.preco_app, 2);
                  Pedido.total = Pedido.subtotal;
                  Pedido.total_com_servico = Pedido.subtotal;
                } else {
                  // MAIOR
                  let precoMaior = montagem
                    .filter((p) => p.TipoMontagem === 'PIZZA' && p.Produto.quantidade > 0)
                    .sort(function (a, b) {
                      return b.Produto.preco_app - a.Produto.preco_app;
                    });

                  if (precoMaior.length > 0) precoMaior = precoMaior[0].Produto.preco_app;
                  else precoMaior = 0;

                  // comentei para testar se resolve o problema da pizza
                  //let somaSubtotais = ArredondaValores(item.Produto.quantidade_fracionada * item.Produto.preco_app, 2);
                  let somaSubtotais = 0; //ArredondaValores(item.Produto.quantidade_fracionada * item.Produto.preco_app, 2);

                  montagem
                    .filter(
                      (p) => p.TipoMontagem.toUpperCase() == 'PIZZA' && p.Produto.quantidade > 0,
                      //p.Produto.codigo !== PRODUTO.codigo, // comentei pra ver se resolve o problema da pizza
                    )
                    .map((temp, index) => {
                      const qtdeQuebrar2 = temp.Produto.quantidade - 1 == 0 ? 0 : temp.Produto.quantidade - 1;
                      if (index === 0)
                        somaSubtotais += ArredondaValores(
                          item.Produto.quantidade_fracionada * temp.Produto.preco_app,
                          2,
                        );
                      else somaSubtotais += ArredondaValores(qtdeFracionada * temp.Produto.preco_app, 2);
                      //console.log('449', somaSubtotais);
                      // calcula o valor dos pedaços
                      for (let i = 0; i < qtdeQuebrar2; i++) {
                        somaSubtotais += ArredondaValores(qtdeFracionada * temp.Produto.preco_app, 2);
                        //console.log('453', somaSubtotais);
                      }
                    });

                  const diff = ArredondaValores(precoMaior - somaSubtotais, 2);

                  let newVal = ArredondaValores(diff + item.Produto.quantidade_fracionada * item.Produto.preco_app, 2);
                  newVal = ArredondaValores(newVal / item.Produto.quantidade_fracionada, 2);
                  if (newVal <= 0) {
                    toast.error('Ocorreu um erro ao calcular os valores da pizza');
                    return;
                  }
                  item.Produto.preco_pizza = newVal;
                  Pedido.subtotal = ArredondaValores(item.Produto.quantidade_fracionada * item.Produto.preco_pizza, 2);
                  Pedido.total = Pedido.subtotal;
                  Pedido.total_com_servico = Pedido.subtotal;
                }
                HandleAddItem(dadosApp.Empresa, item.Produto, Pedido, Pedido.observacao_pedido, PrincipalID);
              } else {
                if (item.Produto.id == 0) item.Produto.id = GeraID(PRODUTO.idloja);
                item.Produto.quantidade_fracionada = qtdeFracionada;
                Pedido.subtotal = ArredondaValores(item.Produto.quantidade_fracionada * item.Produto.preco_app, 2);
                Pedido.total = Pedido.subtotal;
                Pedido.total_com_servico = Pedido.subtotal;
                item.Produto.preco_pizza = item.Produto.preco_app;
                HandleAddItem(dadosApp.Empresa, item.Produto, Pedido, '', 0, PrincipalID);
              }

              // grava nova(s) pizza(s) conforme a quantidade que sobrar
              for (let i = 0; i < qtdeQuebrar; i++) {
                //console.log(item.Produto.descricao, 'ID: ' + item.Produto.id);
                //if (item.Produto.id == 0 || item.Produto.id == PrincipalID) item.Produto.id = GeraID(PRODUTO.idloja);
                item.Produto.id = GeraID(PRODUTO.idloja);
                if (pizzQtdePedacos > 1) {
                  item.Produto.quantidade_texto = '1/' + pizzQtdePedacos;
                  item.Produto.tipoPizza = 'FRACAO';
                } else {
                  item.Produto.quantidade_texto = item.Produto.quantidade.toString();
                  item.Produto.tipoPizza = 'INTEIRA';
                }
                item.Produto.quantidade_fracionada = qtdeFracionada;
                Pedido.subtotal = ArredondaValores(item.Produto.quantidade_fracionada * item.Produto.preco_app, 2);
                Pedido.total = Pedido.subtotal;
                Pedido.total_com_servico = Pedido.subtotal;
                item.Produto.preco_pizza = item.Produto.preco_app;
                HandleAddItem(dadosApp.Empresa, item.Produto, Pedido, '', 0, PrincipalID);
              }
            });
        }
        break;

      default:
        PRODUTO.id = PrincipalID;
        PRODUTO.quantidade_texto = PRODUTO.quantidade.toString();
        Pedido.subtotal = ArredondaValores(PRODUTO.quantidade * PRODUTO.preco_app, 2);
        Pedido.total = Pedido.subtotal;
        Pedido.total_com_servico = Pedido.subtotal;

        if (temMontagem) HandleAddItem(dadosApp.Empresa, PRODUTO, Pedido, Pedido.observacao_pedido, PrincipalID);
        else HandleAddItem(dadosApp.Empresa, PRODUTO, Pedido, Pedido.observacao_pedido);
        break;
    }
    // GRAVA O PRODUTO PRINCIPAL

    // GRAVA OS ITENS DE MONTAGEM
    montagem
      .filter(({ Produto, TipoMontagem }) => Produto.quantidade > 0 && TipoMontagem !== 'PIZZA')
      .map((m) => {
        if (m.Produto.id == 0) m.Produto.id = GeraID(PRODUTO.idloja);

        // mudei para multiplicar as quantidades dos itens de montagem baseados na quantidade do produto principal
        m.Produto.quantidade = m.Produto.quantidade * PRODUTO.quantidade;
        // ao editar (GetMontagem), faço o processo inverso, e divido pela quantidade principal

        m.Produto.quantidade_texto = m.Produto.quantidade.toString();
        Pedido.subtotal = ArredondaValores(m.Produto.quantidade * m.Produto.preco_app, 2);
        Pedido.total = Pedido.subtotal;
        Pedido.total_com_servico = Pedido.subtotal;
        switch (m.TipoMontagem) {
          case 'ADICIONAL':
            // CORREÇÃO DO CALCULO DOS ITENS ADICIONAIS MULTIPLICADOS PELA QUANTIDADE DO PRODUTO BASE
            // m.Produto.quantidade_texto = m.Produto.quantidade * PRODUTO.quantidade;
            // Pedido.subtotal = ArredondaValores(m.Produto.quantidade_texto * m.Produto.preco_app, 2);
            // Pedido.total = Pedido.subtotal;
            // Pedido.total_com_servico = Pedido.subtotal;
            // CORREÇÃO DO CALCULO DOS ITENS ADICIONAIS MULTIPLICADOS PELA QUANTIDADE DO PRODUTO BASE
            HandleAddItem(dadosApp.Empresa, m.Produto, Pedido, '', 0, 0, 0, PrincipalID);
            break;

          case 'COMBO':
            Pedido.subtotal = 0;
            Pedido.total = 0;
            Pedido.total_com_servico = 0;
            HandleAddItem(dadosApp.Empresa, m.Produto, Pedido, '', 0, PrincipalID);
            break;

          case 'OBRIGATORIO':
            HandleAddItem(dadosApp.Empresa, m.Produto, Pedido, '', 0, 0, PrincipalID);
            break;

          default:
            break;
        }
      });
    // GRAVA OS ITENS DE MONTAGEM

    // VERIFICA SE EXISTEM PRODUTOS PARA SEREM EXCLUIDOS / EDIÇÃO
    if (itensEdicao.length > 0) {
      let listIdsExcluir = [];

      // verifica o produto principal mudou
      let existe = itensEdicao.filter(
        (p) =>
          p.id > 0 &&
          p.codigo_produto !== PRODUTO.codigo &&
          p.quantidade > 0 &&
          p.montagem_id === 0 &&
          p.obrigatorio_id === 0 &&
          p.adicionais_id === 0,
      );
      if (existe?.length > 0) listIdsExcluir.push(existe[0].id);

      // verifica os itens de montagem
      itensEdicao.map((item) => {
        let idExcluir = 0;
        // precisa validar a pizza depois

        if (PRODUTO.tipo_produto == 'PIZZA' && tipoPizza == 0) {
          if (item.tipo_produto == 'PIZZA') {
            listIdsExcluir.push(item.id);
          }
        } else {
          idExcluir = montagem.filter(
            (p) => p.Produto.id == item.id && p.Produto.codigo == item.codigo_produto && p.Produto.quantidade == 0,
          );
          if (idExcluir.length > 0) {
            listIdsExcluir.push(idExcluir[0].Produto.id);
          }
        }
      });
      if (listIdsExcluir.length > 0) {
        RemoveItensEdicao(dadosApp.IdLoja, listIdsExcluir);
      }
    } // VERIFICA SE EXISTEM PRODUTOS PARA SEREM EXCLUIDOS / EDIÇÃO

    toast.success('Item adicionado a sacola');
    closeModal();
    UpdateItensCount(dadosApp.IdLoja, setSacola);
  };

  const handlePrincipalDiminuir = () => {
    if (PRODUTO.quantidade == 1) return;
    PRODUTO.quantidade--;

    setProduto(PRODUTO);
    const newMontagem = montagem.map((item) => {
      return { ...item };
    });
    setMontagem(newMontagem);
    setTimeout(() => {
      handleIsCompleted(
        PRODUTO.quantidade,
        PRODUTO.tipoPizza,
        group,
        handleQtdeSelecionada,
        isCompleted,
        montagem,
        true,
      );
    }, 50);
  };

  const handlePrincipalSomar = () => {
    PRODUTO.quantidade++;
    setProduto(PRODUTO);
    const newMontagem = montagem.map((item) => {
      return { ...item };
    });
    setMontagem(newMontagem);
    setTimeout(() => {
      handleIsCompleted(
        PRODUTO.quantidade,
        PRODUTO.tipoPizza,
        group,
        handleQtdeSelecionada,
        isCompleted,
        montagem,
        true,
      );
    }, 50);
  };

  // const handleChange = (e) => {
  //   const { value } = e.target;
  //   setObservacao(value);
  // };

  const handleSetInitialObs = useCallback(() => {
    setValue('observacao', PRODUTO.observacao, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [PRODUTO.observacao, setValue]);



  useEffect(() => {
    handleSetInitialObs();
  }, [handleSetInitialObs]);

  useEffect(() => {
    handleIsCompleted(PRODUTO.quantidade, PRODUTO.tipoPizza, group, handleQtdeSelecionada, isCompleted, montagem);

    //return () => handleClearMontagem(); // comentei 31/03/2023
  }, []);

  // effect responsável por limpar os dados de montagem ao fechar a tela de detalhes
  // useEffect(() => {
  //   return () => {
  //     setUnmounted(!unmounted);
  //     if (unmounted) handleClearMontagem();
  //   };
  // }, [unmounted]); // manter sempre apenas esta dependencia "unmounted"

  useEffect(() => {
    if (PRODUTO.tipo_produto === 'PIZZA' && tipoPizza == 0) {
      montagem
        .filter((p) => p.TipoMontagem === 'PIZZA' && p.Produto.codigo !== PRODUTO.codigo)
        .map((item) => {
          item.quantidade = 0;
        });
    }
  }, [tipoPizza, PRODUTO, montagem]);

  return (
    <>
      {!!PRODUTO.caminho_img && (
        <div id="detail-top" className="thumb_wrap">
          <a className="thumb">
            <Image src={PRODUTO.caminho_img} alt={PRODUTO.descricao} size={'40vh'} />
          </a>
        </div>
      )}
      {PRODUTO.is_principal_multpreco && PRODUTO.tipo_produto !== 'PIZZA' && (
        <div style={{ position: 'sticky', top: '0px', zIndex: '99', background: 'white', height: 61 }}>
          <Tabs
            text1={multPrecos?.length > 0 ? Capitalize(multPrecos[0].titulo) : ''}
            text2={multPrecos?.length > 1 ? Capitalize(multPrecos[1].titulo) : ''}
            text3={multPrecos?.length > 2 ? Capitalize(multPrecos[2].titulo) : ''}
            text4={multPrecos?.length > 3 ? Capitalize(multPrecos[3].titulo) : ''}
            text5={multPrecos?.length > 4 ? Capitalize(multPrecos[4].titulo) : ''}
            codigo_principal={param.item.codigo}
            active={tamanho}
            setTabActive={handleSetTamanho}
          />
        </div>
      )}
      {!PRODUTO.is_principal_multpreco && PRODUTO.tamanho && PRODUTO.tipo_produto !== 'PIZZA' && (
        <div style={{ position: 'sticky', top: '0px', zIndex: '99', background: 'white', height: 61 }}>
          <Tabs
            text1={multPrecos?.length > 0 ? Capitalize(multPrecos[0].titulo) : ''}
            text2={multPrecos?.length > 1 ? Capitalize(multPrecos[1].titulo) : ''}
            text3={multPrecos?.length > 2 ? Capitalize(multPrecos[2].titulo) : ''}
            text4={multPrecos?.length > 3 ? Capitalize(multPrecos[3].titulo) : ''}
            text5={multPrecos?.length > 4 ? Capitalize(multPrecos[4].titulo) : ''}
            codigo_principal={param.item.codigo}
            active={tamanho}
            setTabActive={handleSetTamanho}
          />
        </div>
      )}

      {PRODUTO.tipo_produto == 'PIZZA' && PRODUTO.pizza_qtd_max > 0 && (
        <div style={{ position: 'sticky', top: '0px', zIndex: '99', background: 'white', height: 61 }}>
          <Tabs text1="Inteira" text2="Fração / Sabores" active={tipoPizza} setTabActive={setTipoPizza} />
        </div>
      )}

      {/* <PieChart
        //viewBoxSize={2500}
        //center={[60, 0]}
        //viewBoxSize={[120, 1]}
        label={({ dataEntry }) => dataEntry.title}
        labelStyle={() => ({
          fill: 'white',
          fontSize: '5px',
          fontFamily: 'sans-serif',
          textOverflow: 'ellipsis',
        })}
        labelPosition={50}
        lengthAngle={-360}
        startAngle={125}
        radius={PieChart.defaultProps.radius - 7}
        segmentsShift={(index) => (index === 0 ? 1 : 1)}
        animate
        data={[
          { title: 'Mussarela', value: 1, color: COLORS[0] },
          { title: 'Calabresa', value: 1, color: COLORS[1] },
          { title: 'Frango Catupiry', value: 1, color: COLORS[2] },
          // { title: 'Pizza Frango Catupiry', value: 1, color: COLORS[3] },
        ]}
      /> */}
      {tipoPizza === 0 && (
        <div className="container padTop20 padBottom20">
          {PRODUTO.obs_produto && <p className="padBottom20">{PRODUTO.obs_produto.toLowerCase()}</p>}
          <LabelPreco className="detalhes_preco" price={PRODUTO.preco_app} />
        </div>
      )}

      <div>
        {group.map(function (g, index) {
          return (
            <DetalhesListGroup
              key={index}
              items={montagem.filter((p) => p.Titulo === g)}
              isPizzaFracao={
                PRODUTO.tipo_produto === 'PIZZA' && PRODUTO.pizza_qtd_max > 0
                  ? true
                  : multPrecos?.length > 0
                    ? true
                    : false
              }
            >
              {montagem
                .filter((f) => f.Titulo === g)
                .map(function (item, number) {
                  return (
                    <TemplateSelector
                      key={number}
                      id={number}
                      data={item}
                      action={() => handleOnItemSelect(item)}
                      somar={() => handleMontagemSomar(item)}
                      subtrair={() => handleMontagemSubtrair(item)}
                      handleQtdeSelecionada={handleQtdeSelecionada}
                    />
                  );
                })}
            </DetalhesListGroup>
          );
        })}
      </div>

      {dadosApp.Qs.cardapioDigital !== 'true' && (
        <div className="container padBottom20">
          <h3 className="title_observacao padTop20 padBottom20">Observação</h3>
          <textarea
            rows={3}
            type="textarea"
            placeholder="ex. pouco sal, sem cebola"
            className="observacaoForm"
            {...register('observacao')}
          />
        </div>
      )}

      <div className="spaceBottom" />

      {dadosApp.Qs.cardapioDigital !== 'true' && (
        <DetalhesRodape
          total={TOTAL}
          isCompleted={isCompleted}
          onClick={handleSubmit(addProduto)}
          quantidade={PRODUTO.quantidade}
          onClickDiminui={handlePrincipalDiminuir}
          onClickSoma={handlePrincipalSomar}
          disabled={tipoPizza === 1}
        />
      )}

    </>
  );
};

Detalhes.propTypes = {
  param: P.object,
  closeModal: P.func,
};
